import { createSlice } from '@reduxjs/toolkit';

interface ParentHelperState {
  enabled: boolean;
}

export const initialState: ParentHelperState = {
  enabled: false,
};

export const parentHelperSlice = createSlice({
  name: 'parentHelper',
  initialState,
  reducers: {
    enable: store => {
      store.enabled = true;
    },
  },
});

export const { actions: parentHelperActions, reducer: parentHelperReducer } =
  parentHelperSlice;
